import React, { useState, useEffect, useCallback } from "react";
import Helmet from "react-helmet";
import FadeLoader from "react-spinners/FadeLoader";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns from "./Columns";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getGroupSummaryList } from "store/actions";
import { GROUPSUMMARIZATION } from "common/viewContent";
const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { GROUP_SUMMARY, loading, totalCount } = useSelector(
    (state) => state?.groupSummary
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
  });

  const onCliclNavigate = (summary) => {
    navigate(`/admin/feedback/group-summary/detail`,{ state: { summary: summary } });
  };

  const fetchData = async (filter) => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          //setFeedback(res);
        }
      };
      dispatch(getGroupSummaryList({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  useEffect(() => {
    fetchData(filter);
    setcolumns(
      Columns({ onCliclNavigate, currentPage: filter?.pageNo, pageSize })
    );
  }, [filter]);
  const handlePageChange = (pageNumber) => {
    console.log("pageNumber->", pageNumber);
    setCurrentPage(pageNumber);
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={GROUPSUMMARIZATION.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{GROUPSUMMARIZATION.CURRENT_MODULE}</h1>

          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">
              {GROUPSUMMARIZATION.CURRENT_MODULE}{" "}
            </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">
                    {GROUPSUMMARIZATION.TOP_CONTENT}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          {!loading && GROUP_SUMMARY?.data?.length > 0 && (
            <Table
              data={GROUP_SUMMARY?.data}
              columns={columns}
              setFilter={setFilter}
              handleTableChange={handlePageChange}
              totalCount={totalCount}
              filter={filter}
            />
          )}
          {!loading && GROUP_SUMMARY?.data?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Group Summary Found</p>
          )}
        </div>
      </section>
    </>
  );
};
export default List;
